import { apiClient } from 'services/api-client';
import { Organization } from 'dtos/org/org.dto';
import { Store } from 'dtos/org/store.dto';
import { requireBootstrapAccessToken } from 'services/auth/supabase.client';

export interface BootstrapOrganizationInput {
  name: string;
  full_name?: string;
  store_name: string;
  store_number?: string;
  city?: string;
  state?: string;
  timezone?: string;
  tier?: 'core' | 'pro' | 'advanced';
}

export interface BootstrapOrganizationResult extends Organization {
  first_store: Store;
}

export interface CreateStoreInput {
  name: string;
  store_number?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  timezone?: string;
  phone?: string;
}

export class OrganizationService {
  static async bootstrap(input: BootstrapOrganizationInput): Promise<BootstrapOrganizationResult> {
    await requireBootstrapAccessToken();
    const response = await apiClient.post<BootstrapOrganizationResult>('/orgs', input);
    return response.data;
  }

  static async createStore(orgId: string, input: CreateStoreInput): Promise<Store> {
    const response = await apiClient.post<Store>(`/orgs/${orgId}/stores`, input);
    return response.data;
  }

  static async updateStore(orgId: string, storeId: string, input: CreateStoreInput): Promise<Store> {
    const response = await apiClient.patch<Store>(`/orgs/${orgId}/stores/${storeId}`, input);
    return response.data;
  }
}
